package com.parmartechnologies.core.feature.businessConnection.model

import com.parmartechnologies.core.extension.BaseDataClass
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlin.time.Clock
import kotlin.time.ExperimentalTime

@Serializable
data class BusinessConnection @OptIn(ExperimentalTime::class) constructor(
    @SerialName("unique_id") var UniqueId: Long = Clock.System.now().epochSeconds,
    @SerialName("from_user_id") var fromUserID: String = "",
    @SerialName("to_user_id") var toUserID: String = "",
    @SerialName("from_business_id") var fromBusinessID: String = "",
    @SerialName("to_business_id") var toBusinessID: String = "",
    @SerialName("is_sent") var isSent: Int = 0,
    @SerialName("is_accepted") var isAccepted: Int = 0,
    @SerialName("is_rejected") var isRejected: Int = 0,
    @SerialName("is_deleted") var IsDeleted: Int = 0,
): BaseDataClass()